import { Component, ElementRef, ViewChild } from '@angular/core';
import {
  Checklist,
  ChecklistItem,
  ChecklistItemEnum,
} from '../../../core/models/vanTransfer.model';
import { fabric } from 'fabric';

@Component({
  selector: 'app-checklist-van',
  templateUrl: './checklist-van.component.html',
  styleUrls: ['./checklist-van.component.scss'],
})
export class ChecklistVanComponent {
  @ViewChild('canvas') canvasEl: ElementRef | undefined;
  canvas: fabric.Canvas | undefined;
  checklist: Checklist = new Checklist('');
  checklistPoint: any[] = [[], []];
  checklistPointActual = '';
  public checklistItemsEnums: any = Object.values(ChecklistItemEnum).slice(
    0,
    Object.keys(ChecklistItemEnum).length / 2
  );

  removePoint(item: string) {
    let index = this.checklistPoint[0].findIndex((itemPoint: string) => {
      if (itemPoint == item) {
        return true;
      }
      return false;
    });
    if (index > -1) {
      this.checklistPoint[0].splice(index, 1);
      this.canvas!.remove(this.checklistPoint[1][index]);
      this.checklistPoint[1].splice(index, 1);
    }
  }
  ngAfterViewInit() {
    this.canvas = new fabric.Canvas(this.canvasEl!.nativeElement);
    let element = document.getElementById('checklist');
    let elementDivCanvas = document.getElementById('div-canvas');
    fabric.Image.fromURL(
      '../../../../assets/images/van.jpg',
      (img: fabric.Image) => {
        img.lockUniScaling = true;
        img.lockRotation = true;
        img.lockScalingFlip = true;
        img.lockMovementX = true;
        img.lockMovementY = true;
        img.selectable = false;
        img.sendToBack();
        this.canvas!.setHeight(element?.offsetHeight ?? 800);
        this.canvas!.setWidth(elementDivCanvas?.offsetWidth ?? 600);
        img.scaleToWidth(this.canvas!.getWidth() ?? 800);
        this.canvas!.add(img);
        this.canvas!.on('mouse:down', (options: any) => {
          if (options.target) {
            var pointer = this.canvas!.getPointer(options.e);
            var circle = new fabric.Circle({
              radius: 10,
              left: pointer.x,
              top: pointer.y,
              lockRotation: true,
              hasBorders: true,
              borderColor: 'red',
              cornerColor: 'red',
              fill: 'red',
              cornerSize: 10,
              transparentCorners: false,
            });

            // Adiciona um número dentro do círculo
            const text = new fabric.Text('42', {
              fontSize: 15,
              fill: 'white',
              originX: 'center',
              originY: 'center',
            });
            text.set({
              top: pointer.y - text!.height! / 2,
              left: pointer.x - text!.width! / 2,
            });

            // canvas.add(text);

            // const group = new fabric.Group([circle, text], {
            // left: circle.left,
            // top: circle.top,
            //  });

            if (
              !this.checklistPoint[0].includes(this.checklistPointActual) &&
              this.checklistPointActual != ''
            ) {
              this.checklistPoint[0].push(this.checklistPointActual);
              this.checklistPoint[1].push(circle);
              circle.bringToFront();
              this.canvas!.add(circle);
            }
          }
        });
      }
    );
  }
}
